export const checkNavigable = link => {
  let value = []
  if (typeof window !== "undefined" && localStorage?.allowed_menu) {
    value = localStorage?.allowed_menu
    value = value.split(",")
  }
  return typeof window !== "undefined" && value?.includes(link)
}

export const getAndSetNavigable = (data, dispatch) => {
  let value = []
  if (typeof window !== "undefined" && localStorage?.allowed_menu) {
    value = localStorage.allowed_menu
    value = value.split(",")
    value = new Set([...value, ...data])
    localStorage.allowed_menu = [...value]
    dispatch({ type: "LAYOUT_REFRESH", payload: true })
  } else {
    localStorage.setItem("allowed_menu", data)
    dispatch({ type: "LAYOUT_REFRESH", payload: true })
  }
}
